"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "parenti": {
    "3480ea5f": [{
      "hkey": "0ceb0f33",
      "slug": "carito-santa-maria",
      "name": "Carito-Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "carito": [{
      "hkey": "0ceb0f33",
      "slug": "carito-santa-maria",
      "name": "Carito-Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2b394fd9": [{
      "hkey": "1fc55a47",
      "slug": "parenti",
      "name": "Parenti",
      "primary": true,
      "skipSearch": false
    }],
    "carroi": [{
      "hkey": "1fc55a47",
      "slug": "parenti",
      "name": "Parenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c1d8330": [{
      "hkey": "1fc55a47",
      "slug": "parenti",
      "name": "Parenti",
      "primary": true,
      "skipSearch": false
    }],
    "centrale-savuto": [{
      "hkey": "1fc55a47",
      "slug": "parenti",
      "name": "Parenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5bc7824e": [{
      "hkey": "1fc55a47",
      "slug": "parenti",
      "name": "Parenti",
      "primary": true,
      "skipSearch": false
    }],
    "marcillera": [{
      "hkey": "1fc55a47",
      "slug": "parenti",
      "name": "Parenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5007fd0b": [{
      "hkey": "1fc55a47",
      "slug": "parenti",
      "name": "Parenti",
      "primary": true,
      "skipSearch": false
    }],
    "trencato": [{
      "hkey": "1fc55a47",
      "slug": "parenti",
      "name": "Parenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "81c54f2c": [{
      "hkey": "00741085",
      "slug": "vallelaposta",
      "name": "Vallelaposta",
      "primary": true,
      "skipSearch": false
    }],
    "valle-la-posta": [{
      "hkey": "00741085",
      "slug": "vallelaposta",
      "name": "Vallelaposta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4164fa68": [{
      "hkey": "1fc55a47",
      "slug": "parenti",
      "name": "Parenti",
      "primary": true,
      "skipSearch": false
    }],
    "vermiglia": [{
      "hkey": "1fc55a47",
      "slug": "parenti",
      "name": "Parenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;